export default __webpack_public_path__ + "static/media/exit.1b7b992f.svg";